import { Division } from "./actions";
import { DivisionState } from "./reducer";

const selectSlice = (state: any): DivisionState => state.divisionManager;

export const getDivisionList = (state: any): Division[] => selectSlice(state)?.list ?? [];
export const getDivisionLoading = (state: any): boolean => !!selectSlice(state)?.loading;
export const getDivisionSaving = (state: any): boolean => !!selectSlice(state)?.saving;
export const getDivisionError = (state: any): string | undefined => selectSlice(state)?.error;
export const getFilterName = (state: any): string => selectSlice(state)?.filterName ?? "";
export const getModalOpen = (state: any): boolean => !!selectSlice(state)?.modalOpen;
export const getEditingItem = (state: any): Division | null => selectSlice(state)?.editing ?? null;

export const getFilteredDivisionList = (state: any): Division[] => {
  const list = getDivisionList(state);
  const q = (getFilterName(state) || "").trim().toLowerCase();
  let data = list;
  if (q) data = data.filter(d => d.name?.toLowerCase().includes(q));
  return [...data].sort((a, b) => (a.name || "").localeCompare(b.name || ""));
};